// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export interface Document {
  [key: string]: any;
}
